module.exports = __webpack_public_path__ + "img/_ico.680af00b.svg";